



















import { Component, Vue, Prop } from 'vue-property-decorator';
import snackBarService from './snackbar.service';

@Component({})
export default class SnackBarComponent extends Vue {
  private value: boolean = true;

  private message = 'Error';

  private config = snackBarService;
}
